import translate from "@insite/client-framework/Translate";
import { IconWrapper } from "@insite/mobius/Icon";
import Mail from "@insite/mobius/Icons/Mail";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import applyPropBuilder from "@insite/mobius/utilities/applyPropBuilder";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import useCreditCode from "@store/Hooks/AccountCenter/useCreditCode";
import { focusStyles } from "@store/theme/common/mixins";
import { MENU } from "@store/theme/design";
import breakpointMediaQueries, { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import React from "react";
import { css, withTheme } from "styled-components";

interface OwnProps extends LinkProps {}

const MessageLink: React.FC<OwnProps> = withTheme(({ ...otherProps }) => {
    const { applyProp } = applyPropBuilder(otherProps, { component: "link" });
    const hasAccountMessages = !useCreditCode().isNoCreditCode;

    const accountMessageNotificationStyles = () => {
        if (hasAccountMessages) {
            return css`
                &::after {
                    content: "!";
                    position: absolute;
                    top: -2px;
                    right: -4px;
                    width: 11px;
                    height: 11px;
                    display: flex;
                    border-radius: 50%;
                    font-size: 9px;
                    align-items: center;
                    justify-content: center;
                    background-color: ${getColor("danger")};
                    color: ${getColor("common.background")};
                }
            `;
        }
    };

    const messagesLinkStyles: LinkPresentationProps = {
        icon: {
            iconProps: {
                size: 22,
                src: Mail,
                css: css`
                    margin-right: 0;
                `,
            },
        },
        css: css`                
            ${focusStyles()}
            ${IconWrapper} {
                position: relative;
                height: auto;

                ${accountMessageNotificationStyles}
            }
            ${props =>
                breakpointMediaQueries(
                    props.theme,
                    [
                        css`
                            height: 100%;
                            padding: ${MENU.mobileButtonSpacing};
                        `,
                        null,
                        css`
                            height: auto;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    };

    return (
        <>
            <Link href={applyProp("href")} {...messagesLinkStyles}>
                <VisuallyHidden>{translate("Messages")}</VisuallyHidden>
            </Link>
        </>
    );
});

export default MessageLink;
